// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_UploadFotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/site_unidades/upload_foto
 *
 * Multipart form: `foto` (image file). Same artefacts as the profile-image
 * upload (Usuarios_UploadImagemPerfilInput): the file lives in $_FILES, the
 * JSON contract layer is bypassed.
 */
import { registerContract } from './validate'

export interface SiteUnidades_UploadFotoInput {
_files: unknown[]
}

registerContract('SiteUnidades_UploadFotoInput', {
  _files: { type: 'array',   required: true },
})
